import { z } from 'zod';

import { isType } from '../is-type';

const ALLOWED_PROTOCOLS = ['http:', 'https:'];

const urlOrDomainSchema = z.string().refine(
  value => {
    const fullUrlResult = z.string().url().safeParse(value);

    if (fullUrlResult.success) {
      try {
        const url = new URL(value);

        if (!ALLOWED_PROTOCOLS.includes(url.protocol)) {
          return false;
        }

        return true;
      } catch {
        return false;
      }
    }

    const parts = value.split('.');

    if (parts.length < 2) {
      return false;
    }

    for (const part of parts) {
      if (
        part.length === 0 ||
        part.length > 63 ||
        !/^[a-zA-Z0-9-]+$/.test(part) ||
        part.startsWith('-') ||
        part.endsWith('-')
      ) {
        return false;
      }
    }

    try {
      new URL(`http://${value}`);

      return true;
    } catch {
      return false;
    }
  },
  {
    message: 'Must be a valid URL or domain name',
  },
);

export const checkIsDomainOrUrl = isType(urlOrDomainSchema);
